export default __webpack_public_path__ + "static/media/StickinessIcon.4cd4f091.svg";